var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2111_3116)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1335 23.9776C19.4423 23.9776 18.8322 23.8624 18.3031 23.632C17.774 23.4016 17.3602 23.0347 17.0615 22.5312C16.7714 22.0277 16.6263 21.3792 16.6263 20.5856V19.1264C16.6263 18.6997 16.6263 18.2816 16.6263 17.872C16.6263 17.4539 16.6263 17.0357 16.6263 16.6176C16.6263 16.1909 16.622 15.7685 16.6135 15.3504H18.9175C18.9175 15.76 18.9132 16.1781 18.9047 16.6048C18.9047 17.0229 18.9047 17.4411 18.9047 17.8592C18.9047 18.2773 18.9047 18.6997 18.9047 19.1264V20.368C18.9047 20.9653 18.9772 21.4517 19.1223 21.8272C19.2674 22.1941 19.4807 22.4629 19.7623 22.6336C20.0524 22.8043 20.398 22.8896 20.7991 22.8896C21.2002 22.8896 21.5415 22.8043 21.8231 22.6336C22.1047 22.4544 22.318 22.1813 22.4631 21.8144C22.6167 21.4389 22.6935 20.9483 22.6935 20.3424V15.3504H23.6407V20.3808C23.6407 21.1829 23.5042 21.8528 23.2311 22.3904C22.9666 22.9195 22.574 23.3163 22.0535 23.5808C21.533 23.8453 20.893 23.9776 20.1335 23.9776ZM15.6279 16.1952V15.3504H20.0439V16.1952L18.2775 16.272H17.3047L15.6279 16.1952ZM21.5287 16.1952V15.3504H24.7031V16.1952L23.3335 16.2464H22.9879L21.5287 16.1952Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2111_3116",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2B5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.d7e8b82690725674d6d9f811c80f1f86.svg";
export { ForwardRef as ReactComponent };